export type CoachingDuration = 1 | 3 | 6 | 12;

const COACHING_PRICES = {
  standart: { 1: 2750, 3: 7750, 6: 14750, 12: 28350 },
  premium: { 1: 3500, 3: 9850, 6: 18850, 12: 36150 },
} as const;

export const COACHING_DURATIONS: CoachingDuration[] = [1, 3, 6, 12];

export function getCoachingDurationPrice(
  packageTitle: string,
  duration: CoachingDuration,
) {
  const normalizedTitle = packageTitle.toLocaleLowerCase("tr-TR");
  const packageKey = normalizedTitle.includes("premium")
    ? "premium"
    : normalizedTitle.includes("standart")
      ? "standart"
      : null;
  if (!packageKey) return null;

  const total = COACHING_PRICES[packageKey][duration];
  const monthlyPrice = COACHING_PRICES[packageKey][1];
  const regularTotal = monthlyPrice * duration;
  const savings = regularTotal - total;
  const discountPercent = Math.round((savings / regularTotal) * 100);

  return {
    total,
    monthlyEquivalent: total / duration,
    regularTotal,
    savings,
    discountPercent,
  };
}
